import React, {useEffect, useState} from 'react';
import moment from 'moment/moment';
import actions from '../../redux/actions';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import CustomInput from '../../common/components/CustomInput/CustomInput';
import CustomSelect from '../../common/components/CustomSelect/CustomSelect';
import './Affiliates.scss';
import Button from '../../common/components/Button/Button';
import Loader from '../../common/components/Loader/Loader';
import PersonInfoCard from '../../common/components/PersonInfoCard/PersonInfoCard';
import Table from '../../common/components/ItemTable/v2/Table';
import {affiliatePlansHeaders, createdDateHeader, downDateHeader} from '../../utils/tableHeaders';
import {random} from 'lodash';
import Cancel from '../../assets/icons/Cancel';
import {validateSearch} from '../../utils/documentsValidation';
import CreateAttention from '../CreateAttention/CreateAttention';

const _Affiliates = (props) => {
    const {
        affiliates,
        getAffiliate,
        getAffiliatesState,
        cleanAffiliates,
        cleanGetAffiliatesState,
        role,
    } = props;

    useEffect(() => {
        cleanSearch();
        cleanGetAffiliatesState();
        // eslint-disable-next-line
    }, []);

    moment.locale('es');

    const [search, setSearch] = useState('');
    const [searchTag, setSearchTag] = useState('document');
    console.log('searchTag', searchTag);
    const [simulatingAttention, setSimulatingAttention] = useState(false);

    const handleSearch = () => {
        setSimulatingAttention(false);
        getAffiliate(search, searchTag);
    };


    const tagNames = [
        {value: 'document', label: 'Documento'},
        {value: 'affiliateNumber', label: 'Credencial'},
    ];

    const cleanSearch = () => {
        setSimulatingAttention(false);
        cleanAffiliates();
        setSearch('');
        cleanGetAffiliatesState();
    };

    const handleSimulationButton = () => {
        cleanGetAffiliatesState();
        setSimulatingAttention(true);
    };


    useEffect(() => {
        search && handleSearch();
    }, [searchTag]);


    const hasActivePlansF = (affiliates) => {
        if (!affiliates || affiliates.length === 0) {
            console.warn('No hay afiliados o la estructura de datos es incorrecta.');
            return false;
        }

        for (const affiliate of affiliates) {
            if (affiliate.status === 'Activo') {
                return true;
            }
        }
        return false;
    };

    const affiliateWithPlans = () => {
        const sortedAffiliates = [...affiliates].sort((a, b) => {
            if (a.status === 'Activo' && b.status !== 'Activo') return -1;
            if (a.status !== 'Activo' && b.status === 'Activo') return 1;
            return 0;
        });

        const hasActivePlans = hasActivePlansF(affiliates);
        const medicalCoverage = affiliates[0].medicalCoverage;

        const affiliateStatus = hasActivePlans ? 'Activo' : 'Inactivo';
        const affiliateStatusColor = hasActivePlans ? 'green' : 'red';
        const displayName = medicalCoverage
            ? `${affiliates[0].fullName} - ${medicalCoverage}`
            : affiliates[0].fullName;
        return (
            <>
                <PersonInfoCard fullName={displayName}
                attributes={[
                    `DNI: ${affiliates[0].documentNumber}`,
                    <span key="affiliateStatus" style={{color: affiliateStatusColor, fontWeight: 'bold'}}>Estado: {affiliateStatus}</span>,
                    // `Credencial: ${affiliates[0].affiliateNumber}`,
                   ]}/>

                {!medicalCoverage &&
                    sortedAffiliates.map((affiliate) => (
                        <div className={'affiliates-plans-container'} key={affiliate.affiliateNumber}>
                            <p className={'subtitle-1 v2-c-primary-500'}>Planes {affiliate.status === 'Activo' ? 'Activos' : 'Inactivos'}</p>
                            <div style={{height: '300px', width: '100%'}}>
                                <Table
                                    attributes={affiliatePlansHeaders(affiliate.status === 'Activo' ? [createdDateHeader] : [downDateHeader])}
                                    rows={affiliate.plans.map((plan) => ({
                                        ...plan,
                                        status: affiliate.status,
                                        id: random(0, 10000),
                                        affiliateNumber: affiliate.affiliateNumber,
                                        downDate: affiliate.downDate || '',
                                        createdDate: plan.createdAt || '',
                                    }))}
                                    rowCount={affiliate.plans.length}
                                    pageSize={affiliate.plans.length}/>
                            </div>
                        </div>
                    ))
                }
            </>
        );
    };

    return (
        <div className={'page-content-container'}>
            <p className={'h3 v2-c-text-title'}>Consulta de Cobertura</p>
            <div className={'affiliates-information-container'}>
                <div className={'affiliates-options-container'}>
                    <CustomSelect label={'Tipo de identificación'} value={searchTag} options={tagNames}
                                  onChange={(value) => setSearchTag(value)}/>
                    <form className={'width-100'} onSubmit={(e) => {
                        e.preventDefault();
                        if (validateSearch(search, searchTag)) {
                            handleSearch();
                        }
                    }}>
                        <CustomInput
                            value={search}
                            onChange={(value) => setSearch(value)}
                            rightSlot={<Cancel width={'10px'} height={'10px'}/>}
                            rightSlotOnClick={() => {
                                cleanSearch();
                            }}
                            placeholder={`N° de ${tagNames.find((tag) => tag.value === searchTag).label.toLowerCase()}`}
                            label={`N° de ${tagNames.find((tag) => tag.value === searchTag).label.toLowerCase()}`}
                            type={searchTag === 'affiliateNumber' ? 'credential' : 'text'}
                        />
                    </form>
                </div>
                <div className={'flex-aligned-justified-center v2-row gap-8'}>
                    <Button size={'medium'} onClick={handleSearch} disabled={!validateSearch(search, searchTag) }>Buscar afiliado</Button>
                    {role !== 'PROVIDER_USER_VIEWER' &&
                        getAffiliatesState.success &&
                        affiliates.length > 0 &&
                        (affiliates[0]?.medicalCoverage ||
                            affiliates.some((affiliate) => affiliate.status === 'Activo')) && (
                        <Button
                            size={'medium'}
                            onClick={handleSimulationButton}
                        >
                            Consultar coberturas
                        </Button>
                    )}                </div>
                {simulatingAttention ? <CreateAttention isSimulation={true} onExitSimulation={cleanSearch}/> :
                getAffiliatesState.loading ? <Loader height={100} width={100}/> :
                    <div className={'affiliate-search-result-container'}>
                        {getAffiliatesState.success ? affiliates?.length > 0 ?
                            affiliateWithPlans() :
                                <PersonInfoCard
                                    fullName={'Afiliado no encontrado'}
                                    attributes={[searchTag === 'affiliateNumber' ?
                                        'Intente con número de documento' : 'Intente con número de credencial']}
                                /> : <></>
                        }
                    </div>
                }
            </div>
        </div>
    )
        ;
};
const mapStateToProps = (state) => ({
    name: localStorage.getItem('name'),
    title: state.home.title,
    affiliates: state.home.affiliates || [], // Ensure it's always an array
    getAffiliatesState: state.home.getAffiliatesState,
    showSidebar: state.common.showSidebar,
    role: state.login.userInfo.role.name,
});


const mapDispatchToProps = (dispatch) => ({
    getAffiliate: (document, type) => dispatch(actions.home.getAffiliateRequest(document, type)),
    cleanAffiliates: () => dispatch(actions.home.cleanAffiliates()),
    cleanGetAffiliatesState: () => dispatch(actions.home.cleanGetAffiliatesState()),
});

_Affiliates.propTypes = {
    name: PropTypes.string,
    title: PropTypes.string,
    affiliates: PropTypes.object,
    getAffiliatesState: PropTypes.object,
};

export default connect(mapStateToProps, mapDispatchToProps)(_Affiliates);
